<div class="container">
  <ng-container *ngIf="on.loading">
    <div class="loading">
      <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
      <p class="loading-en">Please wait...</p>
      <p class="loading-cn">请稍等</p>
    </div>
  </ng-container>

  <div id="tv-placeholder" *ngIf="!on.loading && on.tvlink">
    <!-- The TV stream will be displayed here -->
    <iframe [src]="on.tvlink | safeUrl "></iframe>
  </div>
</div>